export const AMAZON_AFFILIATE_TAG = 'which1-21';